import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../../models/field.interface';
import { ValidationService, ValidationType } from '../../services/validation.service';

@Component({
  selector: 'app-sectiontitle',
  template: `
  <div [formGroup]="group" *ngIf="field.style.visibility">
  <div class="hazard-description">
    <p class="dynamic-paragraph">{{field.name}} <b *ngIf="field.validation.isRequired">*</b></p>
    <input class="form-control focus-color" style="width:100%" [disabled]="isDisabled()" value="{{field.value}}" placeholder="Enter Section Title" (change)="onChange($event.target)" (mouseenter)="mouseEnter($event.target)" (mouseleave)="mouseLeave($event.target)">
    <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
  </div>
</div>
  `,
  styles: []
})
export class SectiontitleComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  deleteShow = false;
  constructor(
    private _validationService: ValidationService
  ) { } 
  onChange(event) {
    this.field.value = event.value;
    this.group.value[this.field.id] = this.field.value;    
    const data = this.group.value;
    this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onChange]);
  }
  mouseEnter(event) {
    this.field.value = event.value;
  }
  mouseLeave(event) {
    this.field.value = event.value;
  }

  ngOnInit() {
    if (!this.field.dynamic && this.field.value === undefined) {
      this.field.value = '';
    }
    if (this.field.dynamic && this.field.value === undefined) {
      this.field.value = [''];
    }
  }
  isDisabled() : boolean{
    if(!this.field.style.editability)return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/rFF/fields/sectiontitle/sectiontitle.component.ts